import React from "react";
import { useDecision } from "@optimizely/react-sdk";
import { OPTIMIZELY_FLAGS } from "config/optimizely";
import loadable from "@loadable/component";

// Code split V1 and V2 directly (not through Bundles.js to avoid circular dependency)
// Users only download the variant they see
const FacilityPageV1 = loadable(
	() => import(/* webpackChunkName: "FacilityPageV1" */ "./FacilityPage")
);
const FacilityPageV2 = loadable(
	() => import(/* webpackChunkName: "FacilityPageV2" */ "./FacilityPageV2")
);

/**
 * FacilityPage Wrapper - A/B Test Controller
 *
 * This component acts as a router between FacilityPageV1 (legacy) and FacilityPageV2 (new design).
 * It uses Optimizely feature flags to determine which version to render.
 *
 * Decision logic:
 * - If OPTIMIZELY_FLAGS.FACILITY_PAGE_REDESIGN is enabled → Show FacilityPageV2 (new design)
 * - If disabled or flag doesn't exist → Show FacilityPageV1 (legacy)
 *
 * This architecture provides:
 * - Clean separation of concerns
 * - No CSS conflicts between versions
 * - Single decision point for A/B testing
 * - Easy rollback/rollforward capabilities
 */
export default function FacilityPage() {
	const [decision] = useDecision(OPTIMIZELY_FLAGS.FACILITY_PAGE_REDESIGN);
	if (decision?.enabled) {
		return <FacilityPageV2 />;
	}
	return <FacilityPageV1 />;
}
